<script>
import CiCatalogHome from './components/ci_catalog_home.vue';

export default {
  name: 'GlobalCatalog',
  components: { CiCatalogHome },
};
</script>
<template>
  <ci-catalog-home />
</template>
